import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { HttpService } from '../../http.service';
import { BoothTypeService } from '../booth-type.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-booth-type-table',
  templateUrl: './booth-type-table.component.html',
  styleUrls: ['./booth-type-table.component.scss']
})
export class BoothTypeTableComponent {
  title = 'Booth Type';
  displayedColumns: string[] = ['id', 'name', 'code', 'edit'];
  dataSource: any;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private http: HttpService, public boothTypeService: BoothTypeService, private global: GlobalService) {
    this.getBoothTypes();

    this.boothTypeService.downloadBoothType.subscribe((is_update_booth_type) => {
      console.log(is_update_booth_type);
      if (is_update_booth_type) {
        this.getBoothTypes();
      }
    });

    this.global.set_master_page_title = 'Booth Type';


  }

  showBoothTypeRegister() {
    this.boothTypeService.is_display_booth_type_register_component = true;
  }

  hideBoothTypeRegister() {
    this.boothTypeService.is_display_booth_type_register_component = false;
  }

  registerBoothType() {
    this.showBoothTypeRegister();
    console.log('register zone');
    this.boothTypeService.boothTypeUpdate.emit(null);
    this.boothTypeService.set_booth_type_data = null;
  }

  editBoothType(booth_type) {
    this.showBoothTypeRegister();
    console.log(booth_type);
    this.boothTypeService.boothTypeUpdate.emit(booth_type);
    this.boothTypeService.set_booth_type_data = booth_type;
  }

  getBoothTypes() {
    this.http.getBoothTypes().subscribe((data: BoothType[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<BoothType>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }

}

export interface BoothType {
  id: number;
  name: string;
}
